import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Switch } from '@material-ui/core';

/* Status ativo/inativo dos formulários */
const FormStatusSwitch = ({
    activeLabel,
    checked,
    color,
    disabled,
    inactiveLabel,
    name,
    onChange
}) => (
    <FormControlLabel
        label={checked ? activeLabel : inactiveLabel}
        control={
            <Switch
                checked={checked}
                name={name}
                onChange={onChange}
                color={color}
                disabled={disabled}
            />
        }
    />
);

FormStatusSwitch.propTypes = {
    activeLabel: PropTypes.string,
    checked: PropTypes.bool.isRequired,
    color: PropTypes.oneOf([
        'default',
        'primary',
        'secondary'
    ]),
    disabled: PropTypes.bool,
    inactiveLabel: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};

FormStatusSwitch.defaultProps = {
    activeLabel: 'Ativo',
    color: 'primary',
    disabled: false,
    inactiveLabel: 'Inativo'
};

export default FormStatusSwitch;